import { colors } from "styles";

export const SCORE_STATUS = {
  poor: {
    id: "poor",
    label: "POBRE",
    colors: [colors.red, colors.red],
  },
  decent: {
    id: "decent",
    label: "DECENTE",
    colors: [colors.yellow, colors.yellow],
  },
  good: {
    id: "good",
    label: "BUENO",
    colors: [colors.lightGreen, colors.lightGreen],
  },
  excellent: {
    id: "excellent",
    label: "EXCELENTE",
    colors: [colors.green, colors.green],
  },
};

export const DEFAULT_SCORE = 350;

export const MIN_SCORE = 300;
export const MAX_SCORE = 850;
export const MAX_REPAIRABLE_SCORE = 720;

export const INTEREST_PER_STATUS = {
  home: {
    poor: 6.5,
    decent: 5.5,
    good: 4.2,
    excellent: 3.5,
  },
  car: {
    poor: 15,
    decent: 10,
    good: 4,
    excellent: 2.9,
  },
  "credit-card": {
    poor: 30,
    decent: 25,
    good: 21,
    excellent: 18,
  },
  loan: {
    poor: 20,
    decent: 15,
    good: 10,
    excellent: 5,
  },
};

export const LOAN_TYPES = {
  home: {
    img: `https://www.creditrocket.me/wp-content/uploads/2022/04/img-house.jpg`,
    cost: 250000,
    months: 30 * 12,
  },
  car: {
    img: `https://www.creditrocket.me/wp-content/uploads/2022/04/img-car.jpg`,
    cost: 40000,
    months: 60,
  },
  "credit-card": {
    img: "https://www.creditrocket.me/wp-content/uploads/2022/04/img-cards.jpg",
    cost: 10000,
    months: 12,
  },
  loan: {
    img: "https://www.creditrocket.me/wp-content/uploads/2022/04/img-loans.jpg",
    cost: 20000,
    months: 36,
  },
};

const config = {
  api:
    process.env.NODE_ENV === "production"
      ? "https://backend.creditrocket.me"
      : "http://localhost:9000",
  sensitiveData: ["ssn"],
  plans: [
    {
      id: "basic",
      name: ["Plan de Reparación", "de Crédito Ilimitado"],
      description: [
        "Expertos con 10+ años de experiencia",
        "Eliminación de cuentas negativas",
        "Disputas ilimitadas",
        "Servicio garantizado",
        "Portal Personalizado 24/7",
        "Sin contrato",
      ],
      methods: [
        {
          id: "biweekly",
          amount: 4999,
          oldAmount: 69,
          frecuency: "Quincenal",
        },
        {
          id: "monthly",
          amount: 9999,
          oldAmount: 139,
          frecuency: "Mensual",
        },
      ],
      image:
        "https://www.creditrocket.me/wp-content/uploads/2022/06/cr-plan-basico.jpg",
      strikedPrice: 69,
      active: true,
    },
    {
      id: "couples-monthly",
      name: ["Plan de Reparación", "Crédito en pareja"],
      description: [
        "Expertos con 10+ años de experiencia",
        "Eliminación de cuentas negativas de ambos",
        "Disputas ilimitadas",
        "Servicio garantizado",
        "Portal Personalizado 24/7",
        "Sin contrato",
      ],
      image:
        "https://www.creditrocket.me/wp-content/uploads/2022/06/cr-plan-parejas.jpg",
      active: false,
      methods: [{ id: "couples-monthly", amount: 11999, frecuency: "Mensual" }],
    },
    {
      id: "vip-monthly",
      name: ["Plan Ejecutivo ", "Reparación de Crédito"],
      description: [
        "Expertos con 10+ años de experiencia",
        "Eliminación de cuentas negativas",
        "Disputas ilimitadas",
        "Servicio garantizado y exclusivo",
        "Portal Personalizado 24/7",
        "Sin contrato",
        "Analisis mensual de su crédito",
        "Monitoreo de crédito con Smart Credit",
      ],
      image:
        "https://www.creditrocket.me/wp-content/uploads/2022/06/cr-plan-vip.jpg",
      active: false,
      methods: [{ id: "vip-monthly", amount: 13999, frecuency: "Mensual" }],
    },
  ],
  recommendations: [
    {
      id: "collection",
      title: "Eliminar cuentas en colección",
      body: "Cuentas en perdida o que fueron cerradas con marcas negativas.",
      bodyFuture: "Cuentas en colección eliminadas",
      weight: 1,
    },
    {
      id: "late-payments",
      title: "Eliminar pagos atrasados",
      body: "Cuentas en perdida o que fueron cerradas con marcas negativas.",
      bodyFuture: "Pagos atrasados eliminados.",
      weight: 1,
    },
    {
      id: "inquiries",
      title: "Eliminar Indagaciones",
      body: "Una indagación se refiere a una solicitud para mirar su informe de crédito. Multiple indagaciones le afecta su crédito.",
      bodyFuture: "Indagaciones eliminadas.",
      weight: 1,
    },
    {
      id: "authorized-user",
      title: "Mantener sus tarjetas de crédito por debajo del 30%",
      body: "Si usted tiene $1,000 en tarjetas de crédito, al final del mes su cuenta debe reflejar un balance de menos de $300.",
      bodyFuture: "Utilizando menos del 30% en mis tarjetas de crédito",
      weight: 2,
    },
    {
      id: "secured-credit-card",
      title: "Sacar tarjeta asegurada o ser añadido como usuario autorizado",
      body: "Una tarjeta de crédito asegurada es aquella que puede abrir utilizando su propio dinero. También, puede ser añadido como usuario autorizado en tarjetas de un familiar y se le reflejará en su historial.",
      bodyFuture: "Nueva tarjeta asegurada y/o usuario autorizado.",
      weight: 2,
    },
  ],
  secrets: [
    {
      id: "limit-increase",
      image:
        "https://www.creditrocket.me/wp-content/uploads/2022/07/cr-aumento.jpg",
      title: "Solicite un aumento de limite en sus tarjetas de crédito",
      body: "Cada 6 meses, usted puede solicitar un aumento de límite de crédito. Esto le ayudará a disminuir su porcentaje de utilización y aumentará su puntaje de crédito.",
      disclaimer: "Solicitar cada 6 Meses",
    },
    {
      id: "low-spending",
      image:
        "https://www.creditrocket.me/wp-content/uploads/2022/07/cr-30porciento.jpg",
      title: "Mantenga sus tarjetas por debajo del 30% de utilización",
      body: "Si usted tiene $1,000 en tarjetas de crédito, al final del mes su cuenta debe reflejar un balance de menos de $300. De tener un balance mayor, su puntaje de crédito se verá gravemente afectado.",
      disclaimer: "Esta es la razón por la cual su credito no aumenta.",
    },
    {
      id: "family",
      image:
        "https://www.creditrocket.me/wp-content/uploads/2022/07/cr-usuarioautorizado.jpg",
      title:
        "Pídale a algún familiar o amigo que lo añada como usuario autorizado",
      body: "Al ser añadido como usuario autorizado bajo alguien con un buen historial de crédito su puntaje aumentará automaticamente.",
      disclaimer:
        "Ser añadido como usuario autorizado en al menos una tarjeta.",
    },
    {
      id: "negative-accounts",
      image:
        "https://www.creditrocket.me/wp-content/uploads/2022/07/WhatsApp-Image-2022-07-21-at-12.27.40-PM.jpeg",
      title: (
        <>
          <div style={{ color: colors.green }}>Consulta Gratis!</div>
          Comience hoy a Reparar su crédito
        </>
      ),
      body: "Es muy importante mantener limpio su historial de crédito. Por ejemplo, eliminar:",
      highlights: [
        "Cuentas en colección",
        "Pagos atrasados",
        "Cuentas Médicas",
        "Reposesiones de Auto",
        "Bancarrota y otros",
      ],
      disclaimer:
        "Nuestros especialistas estan listos para ayudarle! No espere más. Obtenga el crédito que se merece.",
    },
  ],
};

export default config;
